/**
 * @author Sirisha.M
 * @description 
 */
import { Tag } from 'antd';
import moment from 'moment';
import {
  connect
} from 'react-redux'; 
import React, { Fragment, useState, useEffect, useRef } from 'react'; // Import useState, useEffect, and useRef
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const Area = (props) => {
  const [option, setOption] = useState(getOption(props.selectedThemeing, props.graphprops?.title));
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    translationCache,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const getData = async () => {
    let theme = selectedThemeing;
    requestCheck.current = false;
    let errorInAPIValue = false;
    let noDataInDBValue = false;
    let json = [];
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) || 
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) || 
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) || 
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' &&
          graphprops.DashboardLevelSelection   === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops?.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPIValue = true;
      } else if (json.length === 0) {
        noDataInDBValue = true;
      }
    } else {
      let dates = [];
      let values = [];
      let name = '';
      let tagnames = [];
      let seriesarray = [];
      let legendsdata = [];
      json &&
        Array.isArray(json) &&
        json.map((val) => {
          if (val.Description !== name) {
            if (tagnames.indexOf(val.Description) === -1) {
              tagnames.push(val.Description);
              name = val.Description;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: theme === 'lightTheme' ? 'black' : 'white',
                  fontSize: 16,
                  fontWeight: 'bold',
                },
              });
            }
          }
          return {};
        });

      let yAxisData = [];

      if (Array.isArray(graphprops?.YAxis)) {
        yAxisData = [...graphprops.YAxis];
      }

      let yaxis = yAxisData.map((value, index) => {
        let axis = {};
        axis.splitLine = {
          show: true,
          lineStyle: {
            color: '#504c4c',
          },
          axisLabel: { fontSize: 15 },
        };
        axis.triggerEvent = true;
        axis.axisLine = {
          lineStyle: {
            color:
              graphprops?.colors[index] !== undefined
                ? value && value.tags && value.tags.length > 1
                  ? 'white'
                  : graphprops?.colors[index]
                : 'white',
          },
          axisLabel: { fontSize: 15 },
        };
        axis.max = value.max;
        axis.min = value.min;
        axis.offset = value.offset;
        axis.interval = value.interval;
        axis.position = value.position;
        axis.name = value.name;
        axis.tags = value.tags;
        return axis;
      });

      yaxis.unshift({
        splitLine: {
          show: true,
          lineStyle: {
            color: '#504c4c',
          },
        },
        triggerEvent: true,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
          },
        },
        axisLabel: { fontSize: 15 },
        tags: [],
      });

      tagnames.map((tagval, tagindex) => {
        values = [];
        json.map((jsonval) => {
          if (tagnames[0] === jsonval.Description && tagindex === 0) {
            let date = {};

            date =
              graphprops?.type !== 'summary'
                ? moment
                  .utc(jsonval.DateTime)
                  .tz(currentTimeZone)
                  .format('YYYY-MM-DD HH:mm:ss')
                : moment.tz(currentTimeZone).format('YYYY-MM-DD HH:mm:ss');
            dates.push(date);
          }
          if (tagval === jsonval.Description) {
            values.push(jsonval.Value);
          }
          return {};
        });
        if (graphprops?.linetype === 'area') {
          if (yaxis.length > 1) {
            yaxis.map((axis, axisindex) => {
              if (axis.tags.indexOf(tagval) !== -1) {
                let linetags = graphprops ? graphprops.tags : [];
                if (linetags && linetags.length > 0) {
                  linetags &&
                    linetags.map(() => {
                      seriesarray.push({
                        name: legendsdata[tagindex]['name'],
                        data: values,
                        type: 'line',
                        axisLabel: { fontSize: 15 },
                        yAxisIndex: axisindex,
                        areaStyle: {},
                        smooth: true,
                      });
                      return {};
                    });
                } else {
                  seriesarray.push({
                    type: 'line',
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    axisLabel: { fontSize: 15 },
                    yAxisIndex: axisindex,
                    areaStyle: {},
                    smooth: true,
                  });
                }
              }
              return {};
            });
          } else {
            let linetags = graphprops ? graphprops.tags : [];
            if (linetags && linetags.length > 0) {
              linetags &&
                linetags.map((tag) => {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    type: legendsdata[tagindex]['name'] !== tag ? 'line' : 'bar',
                    axisLabel: { fontSize: 15 },
                    areaStyle: {},
                    smooth: true,
                  });
                  return {};
                });
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type: 'line',
                axisLabel: { fontSize: 15 },
                areaStyle: {},
                smooth: true,
              });
            }
          }
        } else {
          if (yaxis.length > 1) {
            yaxis.map((axis, axisindex) => {
              if (axis && axis.tags && axis.tags.indexOf(tagval) !== -1) {
                let linetags = graphprops ? graphprops.tags : [];
                if (linetags && linetags.length > 0) {
                  linetags &&
                    linetags.map((tag) => {
                      seriesarray.push({
                        name: legendsdata[tagindex]['name'],
                        data: values,
                        yAxisIndex: axisindex,
                        type: legendsdata[tagindex]['name'] !== tag ? 'line' : 'bar',
                        areaStyle: {},
                        axisLabel: { fontSize: 15 },
                      });
                      return {};
                    });
                } else {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    yAxisIndex: axisindex,
                    type: 'line',
                    areaStyle: {},
                    axisLabel: { fontSize: 15 },
                  });
                }
              }
              return {};
            });
          } else {
            let linetags = graphprops ? graphprops.tags : [];
            if (linetags && linetags.length > 0) {
              linetags &&
                linetags.map((tag) => {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    type: legendsdata[tagindex]['name'] !== tag ? 'line' : 'bar',
                    areaStyle: {},
                    axisLabel: { fontSize: 15 },
                  });
                  return {};
                });
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type: 'line',
                axisLabel: { fontSize: 15 },
                areaStyle: {},
              });
            }
          }
        }
        return {};
      });
      const newOption = cloneDeep(getOption(selectedThemeing, graphprops?.title));
      let series = await trendLabelTranslation(seriesarray, translationCache);
      if (
        graphprops &&
        graphprops.area &&
        graphprops.area.colors &&
        graphprops.area.colors.length > 0
      ) {
        newOption.color = [...graphprops.area.colors];
      }
      newOption.xAxis.data = [...dates];
      newOption.yAxis = [...yaxis];
      newOption.series = [...series];
      newOption.legend = [...legendsdata];
      setOption(newOption);
      setRefreshDateTime(moment());
    }
    setErrorInAPI(errorInAPIValue);
    setNoDataInDB(noDataInDBValue);
  };

  // getOption function to generate echarts options
  function getOption(theme, title) {
    return {
      legend: {
        textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' },
        data: [
          {
            name: 'test1',
            icon: 'roundRect',
          },
        ],
      },
      tooltip: {
        trigger: 'axis',
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            backgroundColor: theme === 'lightTheme' ? 'black' : 'black',
            title: 'download',
            name: title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2,
            },
          },
        },
      },
      xAxis: {
        type: 'category',
        data: [], //this.props.graphprops, //remove this to prevent initial warnings
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
          },
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
          },
        },
      },
      yAxis: [
        {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: theme === 'lightTheme' ? 'black' : 'white',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#504c4c',
            },
          },
        },
      ],
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          backgroundColor: '#9a9191',
          textStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ],
      series: [
        {
          data: [],
          type: 'line',
          smooth: true,
          showSymbol: false,
          lineStyle: {
            width: 1,
          },
          // areaStyle: {
          //   opacity: 0.8,
          //   color: new window.echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //     {
          //       offset: 0,
          //       color: 'rgb(255, 255, 255)',
          //     },
          //     {
          //       offset: 1,
          //       color: 'rgb(255, 255, 255)',
          //     },
          //   ]),
          // },
        },
      ],
    };
  }

  // Render method
  return (
    <Fragment>
      {graphprops?.checked === true ? (
        <Tag>{refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}</Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '80%', width: '100%' }}
          className="react_for_echarts"
          theme="light"
        />
      )}
    </Fragment>
  );
};

//export default Area;
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(Area);